import { render, staticRenderFns } from "./CertificatePersonSubsidySchedule.vue?vue&type=template&id=55e324d4&scoped=true"
import script from "./CertificatePersonSubsidySchedule.vue?vue&type=script&lang=js"
export * from "./CertificatePersonSubsidySchedule.vue?vue&type=script&lang=js"
import style0 from "./CertificatePersonSubsidySchedule.vue?vue&type=style&index=0&id=55e324d4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55e324d4",
  null
  
)

export default component.exports